ChangeSetPasswordPopoverView = require 'views/member/change-set-password-popover-view'
CollectionView = require 'views/internal/collection-view'
Confirm = require 'views/lib/confirm'
LoginView = require 'views/member/login-view'
PopOver = require 'views/lib/pop-over'

module.exports = class MemberLoginsView extends CollectionView
  viewType: LoginView

  initialize: ->
    @listenTo @, 'requestSetPassword', @showSetPassword
    super

  showSetPassword: (view) ->
    Confirm.toggle 'cant remove credential', view.popover
      confirmBtnClass: 'confirm'
      fxConfirm: (e) =>
        PopOver.show view.popover
          view: ChangeSetPasswordPopoverView
          options: { @model, @modelCache }



// WEBPACK FOOTER //
// ./app/scripts/views/member/member-logins-view.coffee